import React, { useEffect, useState, useRef } from 'react';
import {
  FormGroup,
  TextField,
  Grid,
  Button,
  Dialog,
  Card,
  Tooltip,
  Autocomplete,
  CardContent,
} from '@mui/material';
import { useHistory } from 'react-router-dom';
import * as Yup from 'yup';
import api from '../../services/api';
import mapboxgl from 'mapbox-gl';
import 'mapbox-gl/dist/mapbox-gl.css';
import MapboxGeocoder from '@mapbox/mapbox-gl-geocoder';
import '@mapbox/mapbox-gl-geocoder/dist/mapbox-gl-geocoder.css';
import './styles.css';
import { useFormik } from 'formik';
import geocoding from '../../components/geocoder';
import axios from 'axios';
import Progress from '../../components/Progress';
import { useDispatch, useSelector } from 'react-redux';
import { setNameProperty } from '../../redux/nameProperty';
import { setDisable } from '../../redux/disable';
import { setLoading } from '../../redux/loading';
import { setNotIsFirstAccess } from 'redux/notIsFirstAccess';
import Success from '../../components/Snack/Success';
import Error from '../../components/Snack/Error';
import { useStyles } from '../../components/Styles';
import { withStyles } from '@mui/styles';
import MuiDialogTitle from '@mui/material/DialogTitle';
import MuiDialogContent from '@mui/material/DialogContent';
import MuiDialogActions from '@mui/material/DialogActions';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Typography from '@mui/material/Typography';
import styleGlobal from '../../Global.module.css';
import maskPhone from '../../components/Masks/maskPhone';
import maskCNPJ from '../../components/Masks/maskCNPJ';
import InfoIcon from '@mui/icons-material/Info';
import NumberFormat from 'react-number-format';
import HelpIcon from '@mui/icons-material/Help';
import SaveButton from 'components/Buttons/ButtonGroup/SaveButton';

mapboxgl.accessToken = 'pk.eyJ1Ijoib3RvbmNicmFnYSIsImEiOiJjazM4Mm1xd2owMGk0M2NzNXMwYjNuOGI4In0.qHXOUHYT4sH5q8cjLlOAtw';

const styles = (theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
  },
  list: {
    width: '100%',
    position: 'relative',
    overflow: 'auto',
    maxHeight: 50,
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
});

const DialogContent = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
}))(MuiDialogContent);

const DialogActions = withStyles((theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(1),
  },
}))(MuiDialogActions);

const DialogTitle = withStyles(styles)((props) => {
  const {
    children, classes, onClose, ...other
  } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton
          aria-label="close"
          className={classes.closeButton}
          onClick={onClose}
          size="large"
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

function Property() {
  const [id, setId] = useState(localStorage.getItem('idProperty'));
  const [open, setOpen] = React.useState(true);
  const [openDialogNoCycle, setOpenDialogNoCycle] = React.useState(false);
  const [openError, setOpenError] = useState(false);
  const [openDia, setOpenDia] = useState(false);
  const [selectedState, handleState] = useState(null);
  const [selectedCity, handleCity] = useState(null);
  const [states, setStates] = useState([]);
  const [cities, setCities] = useState([]);
  const [user, setUser] = useState(null);
  const [dialogIsOpen, setDialogIsOpen] = useState(false);
  const [finishIsOpen, setFinishIsOpen] = useState(false);
  const [openProgress, setOpenProgress] = useState(false);
  const disableB = useSelector((state) => state.disable.disable);
  const error = Error();
  const success = Success();
  const dispatch = useDispatch();
  const nameProperty = useSelector((state) => state.nameProperty.nameProperty);
  const notIsFirstAccess = useSelector(
    (state) => state.notIsFirstAccess.notIsFirstAccess,
  );
  let map; let
    marker;
  const mapContainer = useRef(null);
  const controle = useRef(0);
  const classes = useStyles();
  const selectedCycle = useSelector(
    (state) => state.selectedCycle.selectedCycle,
  );

  const history = useHistory();

  useEffect(() => {
    (async function ini() {
      setUser(await api.get('users'));
    }());
  }, []);

  useEffect(() => {
    if (user?.data.firstAccess === true) {
      setDialogIsOpen(true);
      dispatch(setNotIsFirstAccess(false));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user]);

  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleCloseDialog = () => {
    setOpenDia(false);
  };
  const handleCloseDialogNoCycle = () => {
    setOpenDialogNoCycle(false);
  };

  // Criação dos campos e validação para o formulário
  const formik = useFormik({
    initialValues: {
      name: '',
      owner: '',
      phone: '',
      cnpj: '',
      city: '',
      state: '',
      uf: '',
      street: '',
      number: '',
      longitude: 0,
      latitude: 0,
    },
    validationSchema: Yup.object({
      name: Yup.string().required('Campo Obrigatório').nullable(),
      owner: Yup.string().required('Campo Obrigatório').optional().nullable(),
      cnpj: Yup.string()
        .required('Campo Obrigatório')
        .matches(
          /^[0-9]{2}[.]?[0-9]{3}[.]?[0-9]{3}[/]?[0-9]{4}[-]?[0-9]{2}$/,
          'O número digitado não é válido.',
        )
        .optional()
        .nullable(),
      cep: Yup.string()
        .required('Campo Obrigatório')
        .matches(/^[0-9]{5}[-]?[0-9]{3}$/, 'O número digitado não é válido.')
        .nullable(),
      street: Yup.string().required('Campo Obrigatório').nullable(),
      // district: Yup.string().required("Campo Obrigatório").nullable(),
      number: Yup.number()
        .min(1, 'Número inválido')
        .integer('Número inválido')
        .transform((value) => (isNaN(value) ? undefined : value))
        .typeError(
          'O valor deve ser um número. Caso seja um número decimal utilize " . " ao invés de " , "',
        )
        .nullable(),
      city: Yup.string().required('Campo Obrigatório').nullable(),
      state: Yup.string().required('Campo Obrigatório').nullable(),
      uf: Yup.string().required('Campo Obrigatório').nullable(),
      phone: Yup.string()
        .matches(
          /^[(]?[0-9]{2}[)]?[\s]?[0-9]{5}[-]?[0-9]{4}$/,
          'O número digitado não é válido.',
        )
        .when('userTypeIsLegalPerson', {
          is: true,
          then: (schema) => schema.optional().nullable(),
          otherwise: (schema) => schema.required('Campo Obrigatório'),
        }),
      longitude: Yup.number().nullable(),
      latitude: Yup.number().nullable(),
    }),
    onSubmit: (values) => {
      dispatch(setDisable(true));
      dispatch(setLoading(true));
      dispatch(setNameProperty(values.name));
      // localStorage.setItem("nameProperty", values.name);
      request(values);
    },
  });

  async function request(data) {
    // envia os dados para api salvar no banco
    try {
      const response = await api.get('/users');
      await api
        .put(`/properties/${id}`, {
          ...data,
        })
        .then((resp) => {
          localStorage.setItem('idProperty', resp.data.id);
          localStorage.setItem('nameProperty', resp.data.name);
          dispatch(setNameProperty(resp.data.name));
        });
      success();
      if (user.data.firstAccess) history.push('/pond');
      else if (selectedCycle === null) {
        setOpenDialogNoCycle(true);
        history.push('/property');
      } else history.push('/property');
    } catch (err) {
      error(err.response.data.message);
    } finally {
      dispatch(setDisable(false));
      dispatch(setLoading(false));
    }
  }

  useEffect(() => {
    api
      .get(`/properties/${localStorage.getItem('idProperty')}`)
      .then((property) => {
        if (property.data === '') {
          setOpenDia(true);
        } else formik.setValues(property.data);

        handleStateSelect({
          nome: property.data.state,
          sigla: property.uf || '',
        });
        handleCitySelect({
          nome: property.city,
        });
      });
    async function load() {
      setOpenProgress(true);

      const loadStates = await axios.get(
        'https://servicodados.ibge.gov.br/api/v1/localidades/estados?orderBy=nome',
      );
      if (loadStates.data.length !== 0) {
        setStates(loadStates.data);
      }
      // var resp = await api.get("/properties");
      // setProperties(resp.data);
      // if (resp.data.length === 0) {
      //   setOpenDia(true);
      // }
      setOpenProgress(false);
    }
    load();
  }, [nameProperty]);

  useEffect(() => {
    if (!mapContainer.current) return;

    map = new mapboxgl.Map({
      container: mapContainer.current,
      style: 'mapbox://styles/mapbox/satellite-streets-v11',
      center: [formik.values.longitude, formik.values.latitude],
      zoom: 2,
    });

    const geocoder = new MapboxGeocoder({
      accessToken: mapboxgl.accessToken,
      localGeocoder: geocoding,
      zoom: 20,
      placeholder: 'Localização',
      language: 'pt-BR',
      marker: false,
      mapboxgl,
    });

    marker = new mapboxgl.Marker()
      .setLngLat([formik.values.longitude, formik.values.latitude])
      .addTo(map);

    const updateMap = () => {
      formik.values.longitude = map.getCenter().lng;
      formik.values.latitude = map.getCenter().lat;
      marker.setLngLat([formik.values.longitude, formik.values.latitude]);
    };

    if (!formik.values.latitude && !formik.values.latitude) {
      map.on('move', updateMap);
    }

    map.on('click', updateMap);
    map.addControl(geocoder);

    map.addControl(new mapboxgl.FullscreenControl());
    map.addControl(new mapboxgl.NavigationControl());

    const load = async () => {
      setOpenProgress(true);
      const loadStates = await axios.get('https://servicodados.ibge.gov.br/api/v1/localidades/estados?orderBy=nome');
      if (loadStates.data.length) setStates(loadStates.data);
      setOpenProgress(false);
    };
    load();
  }, [formik.values.latitude, formik.values.longitude]);

  const handlePropertySelect = async (value) => {
    setId(value.id);
    const new_access = await api.get(`/properties/choose/${value.id}`);

    localStorage.setItem('access_token', new_access.data.access_token);
    localStorage.setItem('idProperty', value.id);
    localStorage.setItem('nameProperty', value.name);
    formik.setValues(value);
    handleStateSelect({
      nome: value.state,
      sigla: value.uf || '',
    });
    handleCitySelect({
      nome: value.city,
    });
    formik.values.longitude = value.longitude;
    formik.values.latitude = value.latitude;
    if (value.longitude && value.latitude) {
      marker.setLngLat([
        parseFloat(value.longitude),
        parseFloat(value.latitude),
      ]);
      map.setCenter({
        lng: formik.values.longitude,
        lat: formik.values.latitude,
      });
    }
    // handleClose();
  };

  // Seta as cidades do estado escolhido
  const handleStateSelect = async (state) => {
    formik.values.state = state.nome;
    formik.values.uf = state.sigla;
    handleState(state);
    formik.values.city = '';
    handleCity(null);
    const loadCities = await axios.get(
      `https://servicodados.ibge.gov.br/api/v1/localidades/estados/${
        state.sigla
      }/municipios`,
    );
    setCities(loadCities.data);
  };

  const handleCitySelect = (city) => {
    formik.values.city = city.nome;
    handleCity(city);
  };

  function onBlurCep(cep) {
    fetch(`https://viacep.com.br/ws/${cep}/json/`)
      .then((res) => res.json())
      .then((data) => {
        const state = states.find((state) => state.sigla === data.uf);
        handleStateSelect(state);
        handleCitySelect({ nome: data.localidade });
        formik.setValues({
          ...formik.values,
          cep,
          street: data.logradouro,
          district: data.bairro,
        });
      });
  }

  // Estilização do tooltip
  const HtmlTooltip = withStyles((theme) => ({
    tooltip: {
      backgroundColor: '#FFFFFF',
      color: 'rgba(0, 0, 0, 0.87)',
      maxWidth: 300,
      fontSize: theme.typography.pxToRem(12),
      border: '1px solid #0367bf',
    },
  }))(Tooltip);

  return (
    <header className={styleGlobal.headerGlobal}>
      {/* <Dialog open={dialogIsOpen} fullWidth>
          <DialogTitle>Bem vindo ao sistema Crevettic</DialogTitle>
          <DialogContent>
            <DialogContentText>
              Vamos iniciar inserindo os primeiros dados da sua fazenda!
            </DialogContentText>
            <DialogContentText>
              Por fim salve para ir para segunda etapa
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setDialogIsOpen(false)}>ok</Button>
          </DialogActions>
        </Dialog> */}
      {openProgress ? <Progress /> : null}
      {' '}
      {/** Carregamento circular para o carregamento dos dados */}
      {/* {properties && (
        <Dialog
          onClose={handleClose}
          aria-labelledby="customized-dialog-title"
          open={open}
        >
          <DialogTitle
            className={classes.list_title}
            id="customized-dialog-title"
            onClose={handleClose}
          >
            Escolha a propriedade
          </DialogTitle>
          <DialogContent dividers>
            <Grid container justify="flex-start">
              <List component="nav" className={classes.list}>
                {properties.map((property) => (
                  <ListItem
                    button
                    onClick={() => handlePropertySelect(property)}
                  >
                    <ListItemAvatar>
                      <Avatar>
                        <ApartmentIcon />
                      </Avatar>
                    </ListItemAvatar>
                    <ListItemText
                      primary={property.name}
                      secondary={`Responsavel: ${property.owner}`}
                    />
                  </ListItem>
                ))}
              </List>
            </Grid>
          </DialogContent>
        </Dialog>
      )} */}
      <Card
        component="form"
        className={classes.root}
        onSubmit={formik.handleSubmit}
        style={{
          padding: '2rem',
          marginBottom: '1rem',
          borderRadius: '20px',
        }}
      >
        <h2 style={{ marginBottom: '2rem' }}>
          Dados da Fazenda
          {' '}
          <HtmlTooltip
            title={(
              <>
                Nessa tela é possível visualizar e editar os “dados da fazenda” cadastrada.
              </>
              )}
            placement="right"
            arrow
            interactive
          >
            <InfoIcon color="primary" fontSize="inherit" />
          </HtmlTooltip>
        </h2>
        {/** *
           *  Diálogo de boas-vindas.
           */}

        <Dialog
          open={openDia}
          onClose={handleCloseDialog}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">
            Primeiramente, registre sua fazenda para ter acesso a outras opções da aplicação localizadas no menu lateral esquerdo.
          </DialogTitle>
          <DialogActions>
            <Button onClick={handleCloseDialog} color="primary">
              Entendi
            </Button>
          </DialogActions>
        </Dialog>

        <Dialog
          open={openDialogNoCycle}
          onClose={handleCloseDialogNoCycle}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">
            {
                'Agora cadastre um ciclo de produção no canto superior direito da tela. '
              }
          </DialogTitle>
          <DialogActions>
            <Button onClick={handleCloseDialogNoCycle} color="primary">
              Entendi
            </Button>
          </DialogActions>
        </Dialog>

        <FormGroup>
          <Grid container spacing={2}>
            {/* <Grid item xs={4}>
                <TextField
                  id="FormGridCPF"
                  label="CPF"
                  variant="outlined"
                  InputLabelProps={{ shrink: true }}
                  name="cpf"
                  type="text"
                  value={formik.values.cpf}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  InputProps={{
                    inputComponent: maskCPF,
                  }}
                  error={formik.touched.cpf && formik.errors.cpf}
                  helperText={formik.touched.cpf && formik.errors.cpf}
                  fullWidth
                />
              </Grid> */}
            <Grid item xs={12} sm={12}>
              <TextField
                id="formGridName"
                label="Nome da Fazenda"
                variant="outlined"
                InputLabelProps={{ shrink: true }}
                name="name"
                type="text"
                value={formik.values.name}
                onChange={formik.handleChange}
                error={!!(formik.touched.name && formik.errors.name)}
                helperText={
                    formik.touched.name
                    && formik.errors.name
                    && formik.errors.name
                  }
                fullWidth
              />
            </Grid>
          </Grid>
        </FormGroup>
        <FormGroup>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6}>
              <TextField
                id="formGridCNPJ"
                className="formGridCNPJ"
                label="CNPJ"
                variant="outlined"
                InputLabelProps={{ shrink: true }}
                name="cnpj"
                InputProps={{
                  inputComponent: maskCNPJ,
                }}
                type="text"
                value={formik.values.cnpj}

                onChange={formik.handleChange}
                error={!!(formik.touched.cnpj && formik.errors.cnpj)}
                helperText={
                    formik.touched.cnpj
                    && formik.errors.cnpj
                    && formik.errors.cnpj
                  }
                fullWidth
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                id="formGridResp"
                label="Razão Social"
                variant="outlined"
                InputLabelProps={{ shrink: true }}
                name="owner"
                type="text"
                value={formik.values.owner}
                onChange={formik.handleChange}
                error={!!(formik.touched.owner && formik.errors.owner)}
                helperText={
                    formik.touched.owner
                    && formik.errors.owner
                    && formik.errors.owner
                  }
                fullWidth
              />
            </Grid>
          </Grid>
        </FormGroup>
        <FormGroup>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={3}>
              <NumberFormat
                fullWidth
                format="#####-###"
                id="formGridCep"
                className="formGridCep"
                label="CEP"
                variant="outlined"
                InputLabelProps={{ shrink: true }}
                name="cep"
                type="text"
                value={formik.values.cep}
                onBlur={() => onBlurCep(formik.values.cep)}
                onChange={formik.handleChange}
                error={!!(formik.touched.cep && formik.errors.cep)}
                helperText={
                    formik.touched.cep && formik.errors.cep && formik.errors.cep
                  }
                customInput={TextField}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                id="formGridStreet"
                className="formGridStreet"
                label={(
                  <div>
                    Logradouro
                    {' '}
                    <HtmlTooltip
                      title={(
                        <>
                          Logradouro é uma rua; um endereço de espaço público ou privado.
                        </>
                      )}
                      placement="right"
                      arrow
                    >
                      <HelpIcon color="primary" fontSize="inherit" />
                    </HtmlTooltip>
                  </div>
)}
                variant="outlined"
                InputLabelProps={{ style: { pointerEvents: 'auto' }, shrink: true }}
                name="street"
                type="text"
                value={formik.values.street}
                onChange={formik.handleChange}
                error={!!(formik.touched.street && formik.errors.street)}
                helperText={
                    formik.touched.street
                    && formik.errors.street
                    && formik.errors.street
                  }
                fullWidth
              />
            </Grid>
            <Grid item xs={12} sm={3}>
              <TextField
                id="formGridNumber"
                className="formGridNumber"
                label="Número (Opcional)"
                variant="outlined"
                InputLabelProps={{ shrink: true }}
                name="number"
                type="number"
                value={formik.values.number}
                onChange={formik.handleChange}
                error={!!(formik.touched.number && formik.errors.number)}
                helperText={
                    formik.touched.number
                    && formik.errors.number
                    && formik.errors.number
                  }
                fullWidth
              />
            </Grid>
          </Grid>
        </FormGroup>
        <FormGroup>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={4}>
              <TextField
                id="formGridPhone"
                label="Telefone"
                variant="outlined"
                InputLabelProps={{ shrink: true }}
                name="phone"
                type="text"
                value={formik.values.phone}
                onChange={formik.handleChange}
                InputProps={{
                  inputComponent: maskPhone,
                }}
                error={!!(formik.touched.phone && formik.errors.phone)}
                helperText={
                    formik.touched.phone
                    && formik.errors.phone
                    && formik.errors.phone
                  }
                fullWidth
              />
            </Grid>
            <Grid item xs={12} sm={4}>
              <Autocomplete
                noOptionsText="Sem opções"
                id="combo-box-demo"
                name="state"
                options={states}
                value={selectedState}
                getOptionLabel={(options) => options.nome || selectedState}
                onChange={(p, v) => {
                  handleStateSelect(v);
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    error={formik.touched.state && formik.errors.state}
                    helperText={formik.touched.state && formik.errors.state}
                    label="Estado"
                    variant="outlined"
                  />
                )}
                disableClearable
              />
            </Grid>
            <Grid item xs={12} sm={4}>
              <Autocomplete
                noOptionsText="Sem opções"
                name="city"
                options={cities}
                value={selectedCity}
                getOptionLabel={(options) => options.nome || formik.values.city}
                onChange={(p, v) => {
                  handleCitySelect(v);
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    error={Boolean(formik.touched.city && formik.errors.city)}
                    helperText={formik.touched.city && formik.errors.city}
                    label="Cidade"
                    variant="outlined"
                  />
                )}
                disableClearable
              />
            </Grid>
          </Grid>
        </FormGroup>

        {/* Mapa da fazenda temporariamente desabilitada */}

        <div id="geocoder" className="geocoder" />

        <div
          ref={(el) => (mapContainer.current = el)}
          className="mapContainer"
        />

        {/* <SaveButton disabled={disableB} onClick={() => { }} /> */}
        <Card
          sx={{
            padding: '0px',
            border: '1px solid #BFC9C2',
            borderRadius: '16px',
            background: '#F8FAF6',
            boxShadow: 'none',
            margin: '16px',
          }}
        >
          <CardContent>
            <Grid
              container
              direction="row"
              justifyContent="flex-end"
              alignItems="flex-end"
              spacing={2}
              padding="16px"
            >
              <Grid item>
                <SaveButton disabled={disableB} />
              </Grid>
            </Grid>
          </CardContent>
        </Card>

        {openError ? error() : null}
      </Card>
    </header>
  );
}
export default Property;
